<script setup>
const props = defineProps({
  $type: String,
  // value: Boolean,
  title: String,
  message: String,
  confirmButtonText: {
    type: String,
    default: '确认'
  },
  cancelButtonText: {
    type: String,
    default: '取消'
  },
  buttonList: {
    type: Array,
    default: () => []
  },
  resolve: Function,
  reject: Function
})

// 维护弹窗显示状态
const visible = ref(true)
const changeBox = (state = false) => (visible.value = state)
// watch(() => props.value, changeBox)

const handleConfirm = () => {
  changeBox()
  props.resolve(true)
}

const handleClose = () => {
  changeBox()
  props.reject(false)
}
const buttonClick = (item) => {
  changeBox()
  props.resolve(item)
}

</script>

<template>
  <nio-dialog v-model="visible" :close-on-click-modal="false">
    <div class="nio-message-box">
      <h4>{{ title }}</h4>
      <p v-html="message" />
      <div class="nio-message-btns" v-if="!buttonList">
        <nio-button v-show="$type !== 'alert'" @click="handleClose">{{ cancelButtonText }}</nio-button>
        <nio-button class="nio-hover" @click="handleConfirm">{{ confirmButtonText }}</nio-button>
      </div>
      <div class="nio-message-btns" v-else>
        <nio-button v-for="(item , index) in buttonList" :key="index" :class="{'nio-hover':index!=0}" @click="buttonClick(item)">{{ item.name }}</nio-button>
      </div>
    </div>
  </nio-dialog>
</template>

<style lang="scss" scoped>
.nio-message-box {
  box-sizing: border-box;
  width: rem(530);
  padding: rem(40);
  text-align: center;
  background-color: #fff;

  h4 {
    margin-bottom: rem(15);
    line-height: rem(25);
  }

  p {
    margin-bottom: rem(30);
    line-height: rem(24);
  }

  .nio-message-btns {
    @include flex-center(flex, space-between);
  }

  .nio-button {
    width: rem(215);
  }
}
</style>
